export enum MessageStatus {
  Draft,
  Sent
}

export enum QuoteOrigin {
  Sub,
  GC
}

export enum QuoteTotalType {
  QuoteAmount,
  PluggedAmount,
  Adjustments
}

export enum AuthenticationMethod {
  None,
  OneClickLink,
  HcssCredentials
}

export enum VendorProposalStatus {
  Sent,
  Received,
  Responded
}

export enum VendorSolicitationStatus {
  SentToSub,
  SubAccepted,
  SubRejected,
  SentToGC,
  GCApproved,
  GCIgnored,
  GCManuallyEntered,
  SyncedToHeavyBid
}

export type SolicitationDashboardFilter = VendorSolicitationStatus | "draft";

export enum VendorSolicitationFilter {
  All,
  New,
  Approved,
  Rejected,
  Pending
}

export enum QuoteAdjustmentType {
  Dollar,
  Percent
}

export enum MessageType {
  Initial = 0,
  Addendum = 1,
  FollowUp = 2,
  Response = 3
}

export enum CommunicationAction {
  SentInitialSolicitationInvite,
  SentFollowupSolicitationInvite,
  SentAddendumSolicitationInvite,
  SubAcceptedInvite,
  SubRejectedInvite,
  SubSubmittedPrices,
  GCReviewedPrices,
  GCRejectedPrices,
  MadePhoneCall,
  ReceivedPhoneCall,
  SentEmail,
  ReceivedEmail,
  SentFax,
  ReceivedFax,
  SentMail,
  ReceivedMail,
  InPersonMeeting,
  GCEnteredPricesOnSubsBehalf,
  GCReconsideredPrices,
  GCManuallyEnteredPrices,
  GCQueuedForSync,
  GCReconsideredManuallyEnteredPrices
}

export enum ExpandableContentStatus {
  expanded = "expanded",
  expanding = "expanding",
  collapsed = "collapsed",
  collapsing = "collapsing"
}

export enum UserType {
  HcssSubscription,
  Subcontractor,
  Guest
}

export enum SharedResourceType {
  VendorSolicitation,
  VendorProposal
}

export enum DataSyncPreferences {
  Neither = "Neither",
  ProjectTracking = "Project Tracking",
  HeavyBid = "HeavyBid"
}

export enum FeatureFlag {
  MultiSelectionField = "MultiSelectionField",
  ContactField = "ContactField",
  LinkToHeavyJob = "LinkToHeavyJob",
  CalculatedField = "CalculatedField",
  ManagedByCompanyAdminField = "ManagedByCompanyAdminFields",
  TableField = "TableField",
  LanguageSelector = "LanguageSelector",
  FrontEndEmailSubscription = "FrontEndEmailSubscription",
  GeocodeLocationFromString = "GeocodeLocationFromString",
  HeavyBidCodeColumn = "HeavyBidCodeColumn",
  NewQuoteManagement = "NewQuoteManagement",
  TakeoffsField = "TakeoffsField"
}
